
<div style="text-align:center; max-width: 40rem; margin: auto">
    <H1>Bonjour {{nom}}</H1>
    <div style="margin: 5em;text-align: center">
        <button pButton label="Fermer la session" (click)="logout()"></button>
    </div>

</div>
